<template>
  <v-layout justify-center>
    <v-dialog v-model="dialog_status"
      scrollable max-width="400px"
      @keydown.esc="close()">

      <v-card>
        <v-card-title>
          BT 프리미엄 회원이 되어주세요!
        </v-card-title>

        <v-card-text>
          <div>회원님, 이 기능은 프리미엄 회원들에게만 제공됩니다.</div>
          <div>비블리오트리즈가 마음에 드셨나요?</div>
          <div>저희의 프리미엄 회원이 되어주세요.</div>
        </v-card-text>

        <v-card-title>프리미엄 회원 특전✨</v-card-title>

        <v-card-text>
          <div>
            <div class="premium-func">
              <div><v-icon color="primary">mdi-check</v-icon></div>
              <div>프로젝트 무제한 생성</div>
            </div>
            <div class="premium-func">
              <div><v-icon color="primary">mdi-check</v-icon></div>
              <div>다른 회원에게 프로젝트 공유</div>
            </div>
            <div class="premium-func">
              <div><v-icon color="primary">mdi-check</v-icon></div>
              <div>관심 도큐먼트를 한 곳에 저장</div>
            </div>
            <div class="premium-func">
              <div><v-icon color="primary">mdi-check</v-icon></div>
              <div>내가 쓴 리뷰 모아보기</div>
            </div>
          </div>
        </v-card-text>

        <v-card-text>
          <div>BiblioTrees는 논문 작성의 든든한 동반자가 되기 위해</div>
          <div>늘 노력하겠습니다.</div>
        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn small text @click="close()">
              {{ $t('actions.close') }}
            </v-btn>
          <v-btn class="primary" @click="toSignup"
            depressed>
            프리미엄 구독하기
          </v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      dialog:'modal/expired_visible',
    }),

    dialog_status: {
      get: function(value) {
        return this.dialog
      },
      set: function(value) {
        if (!value) { this.close() }
      },
    },
  },

  watch: {
    dialog_status(val) {
      this.$analytics.logEvent('click', { name: 'expired_btn_open' })
    },
  },

  methods: {
    close() {
      this.$store.commit('modal/hideExpired')
    },

    toSignup() {
      this.close()
      this.$router.push({ name: 'signup' })
    }
  },
}
</script>

<style scoped>
  .text-block {
    padding-bottom: 12px;
  }

  .premium-func {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
  }

  .premium-func i {
    margin-right: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modal/Expired.vue